import React from 'react';
import { isNullOrUndefined } from "../../../store/storeFunctions";
import { hasPermission } from '../../../store/apiWrapper';
import { Translate } from 'react-localize-redux';
import { withLocalize } from "react-localize-redux";
import AmlCandidatesFilter from './amlCandidatesFilter';
import AmlEntityData from './amlEntityData';
import OldStyleSection from '../../common/oldStyleSection';
import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';
import RelationLink from '../relations/relationLink';
import Semaphore from './semaphore';
import BirthDateWithHighlight from '../../common/birthDateWithHighlight';

class AmlFinalOwnersEval extends React.Component {
    render() {
        return (
            <OldStyleSection name={this.props.translate("Report.Aml.Subjects.FinalOwners")} hasData={this.props.data && this.props.data.length > 0} isOpen isBold>
                <div style={{ paddingLeft: "0.3em", color: "#8d949e" }}>
                    <span style={{ fontWeight: 600 }}><Translate id="Report.Aml.Methodology" />&nbsp;</span>
                    {(methodology => {
                        switch (methodology) {
                            case "cos": return <Translate id="Report.Aml.CosMethodology" />;
                            case "dos": return <Translate id="Report.Aml.DosMethodology" />;
                            default: return null;
                        }
                    })(this.props.methodology)}
                    {!isNullOrUndefined(this.props.share) && !hasPermission(null, "EconomicGroupSberbankMethodologyRole") && <>
                        &nbsp;|&nbsp;<span style={{ fontWeight: 600 }}><Translate id="Report.Aml.MethodologyShare" /></span><span> {this.props.share}%</span>
                    </>}
                </div>
                <AmlCandidatesFilter section={this.props.section} hideRatioFilter={this.props.hideRatioFilter} />
                <OldStyleTableWithHistory tableColumns={3} stripped
                    head={() => this.renderHead()}
                    actualData={this.props.data}
                    actualRow={(r) => this.props.isOnPath ? this.renderPathRow(r) : this.renderRow(r)}
                />
            </OldStyleSection>
        )
    }

    renderHead = () => {
        return (
            <thead className="aml-related-subjects-header">
                <tr>
                    <th><Translate id="Report.Aml.Subjects.MainName" /></th>
                    <th className="col-company-id"><Translate id="Report.Aml.Subjects.IcoBirthDate" /></th>
                    <th className="col-final-owner"><Translate id="Report.Aml.Subjects.FinalOwnerType" /></th>
                    <th className="col-cos">{(this.props.methodology === 'cos' || this.props.isOnPath )&& <Translate id="Report.Aml.Subjects.CumulativeOwnership" />}</th>
                    <th className="col-country"><Translate id="Report.Relations.Country" /></th>
                    <th className="col-aml">AML</th>
                </tr>
            </thead>
        );
    }

    renderRow = (r) => {
        return (
            <React.Fragment key={r.key}>
                <tr className="colorize">
                    <td style={{ fontWeight: "bold" }}><RelationLink wrap entityName={`${r.name || ""} ${r.surname || ""}`.trim()} entityId={r.entityId} reports={r.reports} customPrefix={<></>} showOnMobile={true} /></td>
                    <td>{r.type === "physicalPerson" ? <BirthDateWithHighlight dateAsString={r.birthDateFormatted} isFullDate={!r.isNotFullBirthDate} />  : r.companyId}</td>
                    <td>{r.position}</td>
                    <td>{this.props.methodology === "cos" && r.cumulativeOwnershipInterest && <span>{this.props.isOnPath ? r.Share : r.cumulativeOwnershipInterest + "%"}</span>}</td>
                    <td title={r.country}>{r.countryCode}</td>
                    <td style={{ textAlign: "center" }}><Semaphore color={r.decision} width={20} height={20} /></td>
                </tr>
                {r.candidates && r.candidates.length > 0 && <tr>
                    <td className="nested-table" colSpan={this.props.methodology === "cos" ? 6 : 5}>
                        <AmlEntityData candidates={r.candidates} section={this.props.section} hasBirthDate={!isNullOrUndefined(r.birthDate)} />
                    </td>
                </tr>}
            </React.Fragment>
        );
    }

    renderPathRow = (r) => {
        return (
            <React.Fragment key={r.subject.entityId}>
                <tr className="colorize">
                <td style={{ fontWeight: "bold" }}><RelationLink wrap entityName={`${r.subject.name || ""} ${r.subject.surname || ""}`.trim()} entityId={r.subject.entityId} reports={r.subject.reports} customPrefix={<></>} showOnMobile={true} /></td>
                    <td>{r.subject.type === "P" ? r.subject.birthDateFormatted : r.subject.companyId}</td>
                    <td >{r.relation.RelationName}</td>
                    <td><span>{isNullOrUndefined(r.relation.Share) ? "" : r.relation.Share + "%"}</span></td>
                    {/* <td style={{ textAlign: "right" }}>{!isNullOrUndefined(r.relation.DataDate) ? moment(r.relation.DataDate).format("DD.MM.YYYY") : ""}</td> */}
                    <td title={r.subject.countryFullName}>{r.subject.country}</td>
                    <td style={{ textAlign: "center" }}>
                      <Semaphore color={r.subject.amlReport.decision.toLowerCase()} width={20} height={20} /></td>                
                    </tr>
            </React.Fragment>
        );
    }
}

export default withLocalize(AmlFinalOwnersEval);